// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {PDFFileIndex} from '../search-index/pdffile-index.js'

export class PDFSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFSearchIndex(bb: flatbuffers.ByteBuffer, obj?: PDFSearchIndex): PDFSearchIndex {
    return (obj || new PDFSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFSearchIndex(bb: flatbuffers.ByteBuffer, obj?: PDFSearchIndex): PDFSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pdfFileIndexes(index: number, obj?: PDFFileIndex): PDFFileIndex | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new PDFFileIndex()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  pdfFileIndexesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startPDFSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addPdfFileIndexes(builder: flatbuffers.Builder, pdfFileIndexesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, pdfFileIndexesOffset, 0)
  }

  static createPdfFileIndexesVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startPdfFileIndexesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(1, version, 0)
  }

  static endPDFSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // pdf_file_indexes
    return offset
  }

  static createPDFSearchIndex(
    builder: flatbuffers.Builder,
    pdfFileIndexesOffset: flatbuffers.Offset,
    version: number
  ): flatbuffers.Offset {
    PDFSearchIndex.startPDFSearchIndex(builder)
    PDFSearchIndex.addPdfFileIndexes(builder, pdfFileIndexesOffset)
    PDFSearchIndex.addVersion(builder, version)
    return PDFSearchIndex.endPDFSearchIndex(builder)
  }
}
